import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function Convite() {
  const { token } = useParams();
  const [email, setEmail] = useState('');
  const [nome, setNome] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmar, setConfirmar] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [erro, setErro] = useState('');
  const [valido, setValido] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/auth/convite/${token}`)
      .then(d => { setEmail(d.email); setValido(true); })
      .catch(e => setErro(e.message))
      .finally(() => setLoading(false));
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (senha !== confirmar) return setErro('As senhas não coincidem');
    if (senha.length < 6) return setErro('Senha deve ter ao menos 6 caracteres');
    setSaving(true); setErro('');
    try {
      const data = await api.post(`/auth/convite/${token}`, { nome, senha });
      login(data.token);
      navigate('/dashboard');
    } catch (err) { setErro(err.message); }
    finally { setSaving(false); }
  };

  if (loading) return <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',color:'#6B7289'}}>Verificando convite...</div>;

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',background:'#F4F5F9'}}>
      <div style={{background:'#fff',borderRadius:20,padding:48,width:420,boxShadow:'0 4px 32px rgba(0,0,0,.08)'}}>
        <div style={{fontSize:12,fontWeight:600,color:'#1A2ECC',textTransform:'uppercase',letterSpacing:'.1em',marginBottom:12}}>Cockpit do Importador</div>
        <h2 style={{fontSize:22,fontWeight:700,letterSpacing:'-.02em',marginBottom:6}}>Ative sua conta</h2>
        <p style={{fontSize:13,color:'#6B7289',marginBottom:24}}>Você foi convidado por Guilherme Bressan. Defina seu nome e senha para começar.</p>

        {!valido ? (
          <div style={{background:'#FDEAEA',borderRadius:10,padding:16,fontSize:13,color:'#922020'}}>{erro || 'Convite inválido ou expirado.'}</div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Email</label>
              <input className="input-field" value={email} disabled style={{background:'#F4F5F9',color:'#6B7289'}} />
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Seu nome</label>
              <input className="input-field" placeholder="Nome completo" value={nome} onChange={e=>setNome(e.target.value)} required />
            </div>
            <div style={{marginBottom:12}}>
              <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Senha</label>
              <input className="input-field" type="password" placeholder="Mínimo 6 caracteres" value={senha} onChange={e=>setSenha(e.target.value)} required />
            </div>
            <div style={{marginBottom:20}}>
              <label style={{fontSize:12,fontWeight:500,color:'#6B7289',display:'block',marginBottom:5}}>Confirmar senha</label>
              <input className="input-field" type="password" placeholder="Repita a senha" value={confirmar} onChange={e=>setConfirmar(e.target.value)} required />
            </div>
            {erro && <div style={{background:'#FDEAEA',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#922020',marginBottom:14}}>{erro}</div>}
            <button className="btn-primary" type="submit" disabled={saving} style={{width:'100%',padding:13}}>
              {saving ? 'Ativando...' : 'Ativar minha conta →'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
